import { render, staticRenderFns } from "./OrderProductHistory.vue?vue&type=template&id=23c3f1b4"
import script from "./OrderProductHistory.vue?vue&type=script&lang=ts"
export * from "./OrderProductHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c3f1b4')) {
      api.createRecord('23c3f1b4', component.options)
    } else {
      api.reload('23c3f1b4', component.options)
    }
    module.hot.accept("./OrderProductHistory.vue?vue&type=template&id=23c3f1b4", function () {
      api.rerender('23c3f1b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/OrderProductHistory.vue"
export default component.exports